import { EdgeLocationTableRow } from './types';

import { makeSearchBoxCriteria } from '@cast/shared-search-ui';

export const edgeConfigListId = 'edge-configurations-list';

export const edgeConfigurationCriteria =
  makeSearchBoxCriteria<EdgeLocationTableRow>(
    {
      key: 'Configuration name',
      getValue: (row) => row.configuration.name,
    },
    {
      key: 'Edge location',
      prop: 'edgeLocationName',
    }
  );
